var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelationSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 53,
    r: 52.5,
    fill: "#49712B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4671_87749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 19.5C34.3037 19.5 19.5 34.3037 19.5 52.5C19.5 70.6963 34.3037 85.5 52.5 85.5C70.6963 85.5 85.5 70.6963 85.5 52.5C85.5 34.3037 70.6963 19.5 52.5 19.5ZM52.5 81.375C36.5783 81.375 23.625 68.4217 23.625 52.5C23.625 36.5783 36.5783 23.625 52.5 23.625C68.4217 23.625 81.375 36.5783 81.375 52.5C81.375 68.4217 68.4217 81.375 52.5 81.375ZM69.8838 62.5547C66.2779 68.7996 59.7795 72.5279 52.5005 72.528C45.2213 72.5282 38.7225 68.7998 35.1163 62.5547C34.5467 61.5683 34.8846 60.3068 35.871 59.7373C36.8576 59.1677 38.119 59.5057 38.6883 60.4919C41.5489 65.4457 46.7124 68.4032 52.5004 68.403C58.2881 68.4029 63.4512 65.4455 66.3115 60.4919C66.881 59.5054 68.1425 59.1675 69.1289 59.7372C70.1154 60.3068 70.4533 61.5682 69.8838 62.5547ZM34.7983 44.3716C34.7983 42.0961 36.6496 40.2448 38.9251 40.2448C41.2007 40.2448 43.0519 42.096 43.0519 44.3716C43.0519 46.6471 41.2007 48.4984 38.9251 48.4984C36.6496 48.4984 34.7983 46.6471 34.7983 44.3716ZM70.2018 44.3716C70.2018 46.647 68.3506 48.4984 66.075 48.4984C63.7994 48.4984 61.9482 46.6471 61.9482 44.3716C61.9482 42.096 63.7994 40.2448 66.075 40.2448C68.3504 40.2449 70.2018 42.0961 70.2018 44.3716Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4671_87749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(19.5 19.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelationSmile);
export default __webpack_public_path__ + "static/media/cancelation-smile.6c1a662ee5b4f8dd0ce98d0793f9e4cb.svg";
export { ForwardRef as ReactComponent };